import React from 'react';
import { getVersionNumber } from '../utilities/GetVersionNumber';

function FooterBar() {
  const versionNumber = getVersionNumber();


  return <div className='footer-container'>© SLB {versionNumber}</div>;
}

export default FooterBar;
